import { getTranslationKey } from '@/src/utils/header/headerUtils'
import { Box, Link } from '@mui/material'
import React from 'react'

export interface NavLink {
    label: string
    href: string
    labelKey?: string
    icon?: React.ReactNode
    isActive?: boolean
}

interface HeaderNavigationProps {
    navLinks: NavLink[]
    variant: 'flyin' | 'cleartrip'
    getNavIcon?: (label: string) => React.ReactNode
    t: (key: string) => string
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({ navLinks, variant, getNavIcon, t }) => {
    if (variant === 'cleartrip') {
        return (
            <Box component="nav" sx={{ display: 'flex', gap: 3 }}>
                {navLinks.map(link => (
                    <Link
                        key={link.label}
                        href={link.href}
                        underline="none"
                        sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: link.isActive ? 'primary.main' : 'text.secondary',
                            transition: 'color 0.2s',
                            pb: 0.5,
                            '&:hover': { color: 'primary.main' }
                        }}
                    >
                        {t(link.label.toLowerCase())}
                    </Link>
                ))}
            </Box>
        )
    }

    return (
        <Box component="nav" sx={{ display: 'flex', gap: 2.5 }}>
            {navLinks.map((link, index) => (
                <Link
                    key={link.label}
                    href={link.href}
                    underline="none"
                    sx={{
                        position: 'relative',
                        fontSize: 14,
                        fontWeight: link.isActive ? 600 : 500,
                        color: link.isActive ? 'primary.main' : '#1a2a3a',
                        '&:hover': { color: 'primary.dark' },
                        transition: 'color 0.2s',
                        px: 0.7,
                        display: {
                            xs: index < 2 ? 'flex' : 'none',
                            sm: index < 2 ? 'flex' : 'none',
                            md: 'flex'
                        },
                        alignItems: 'center',
                        // Active-tab indicator: a rounded-top bar dropped to the header's bottom edge.
                        ...(link.isActive && {
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                insetInline: 0,
                                bottom: { xs: -14, sm: -17 },
                                height: 3,
                                borderRadius: '3px 3px 0 0',
                                bgcolor: 'primary.main'
                            }
                        })
                    }}
                >
                    {t(getTranslationKey(link.label, link.labelKey))}
                </Link>
            ))}
        </Box>
    )
}

export { HeaderNavigation }
export type { HeaderNavigationProps }
